import React, { useState } from "react";
import EmailSending from "./EmailSending";
import { Link } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";

const QuoteModal = ({ id, setIsQuoteOpen }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [quoteSuccess, setQuoteSuccess] = useState(false);

  const closeQuoteModal = () => {
    setIsQuoteOpen(false);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setQuoteSuccess(false);
  };

  const firstNameChange = (e) => {
    const input = e.target.value;
    setFirstName(input);
  };

  const lastNameChange = (e) => {
    const input = e.target.value;
    setLastName(input);
  };

  const emailChange = (e) => {
    const input = e.target.value;
    setEmail(input);
  };

  const phoneChange = (e) => {
    const input = e.target.value;
    setPhone(input);
  };

  const postQuoteToServer = async (data) => {
    try {
      setIsSending(true);
      const send = await fetch(
        "https://aquaheat-quotes.herokuapp.com/api/v1/test",
        {
          method: "POST",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );
      if (send) {
        console.log("This will work");
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
        setIsSending(false);
        setQuoteSuccess(true);
      } else {
        console.log("sending failed");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const emailQuoteToUser = (e) => {
    e.preventDefault();
    const quote = {
      userFirstName: firstName,
      userLastName: lastName,
      userEmail: email,
      userPhone: phone,
      quoteID: id,
    };
    console.log(quote);
    postQuoteToServer(quote);
  };

  return (
    <div>
      <button className="close-quote" onClick={closeQuoteModal}>
        <IoCloseSharp />
      </button>
      <div className={quoteSuccess ? "quote-saved__success" : "hide"}>
        <h2 className="title">Success</h2>
        <p class="price-card-title">Your quote has been emailed to you.</p>
        <Link className="btn-hero btn-quote" to="/" onClick={closeQuoteModal}>
          Return To HomePage
        </Link>
      </div>
      <div className={isSending ? "quote-saved__success" : "hide"}>
        <EmailSending />
      </div>
      <div className={quoteSuccess || isSending ? "hide" : "modal-card"}>
        <h1 className="title">Send My Fixed Price Quote</h1>
        <form>
          <div className="form-controller">
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={firstNameChange}
              className="quote-form_input"
            />
          </div>
          <div className="form-controller">
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={lastNameChange}
              className="quote-form_input"
            />
          </div>
          <div className="form-controller">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={emailChange}
              className="quote-form_input"
            />
          </div>
          <div className="form-controller">
            <input
              type="text"
              placeholder="Phone"
              value={phone}
              onChange={phoneChange}
              className="quote-form_input"
            />
          </div>
          <button className="quote-form_btn" onClick={emailQuoteToUser}>
            Save Quote
          </button>
        </form>
      </div>
    </div>
  );
};

export default QuoteModal;
